import {useEffect} from "react";
import {useLocation} from "react-router-dom";

import {isGlitchTipEnabled, setGlitchTipRoute} from "@/src/modules/core/lib/glitchtip";

export function GlitchTipRouteSync() {
  const location = useLocation();

  useEffect(() => {
    if (!isGlitchTipEnabled()) return;
    const route = location.hash.replace(/^#/, "") || location.pathname;
    setGlitchTipRoute(route);
  }, [location.pathname, location.hash]);

  return null;
}
